<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #toolbar>
      <router-link
        v-if="userCan('create.bank')"
        :to="{ name: 'BankCreate' }"
        class="button button--primary poppins"
      >
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
        Bank
      </router-link>
    </template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Bank Name"
              v-model="formData.search"
            />
          </div>
          <div class="form-search__double">
            <label class="form__label">Group</label>
            <select
              class="form__input"
              v-model="formData.group_id"
            >
              <option value="">Show All</option>
              <option
                v-for="row in listBankGroup"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-search__action">
          <div class="w-full flex">
            <BaseButton type="submit" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="default"
              @click="reset"
              >Reset Search</BaseButton
            >
          </div>
        </div>
      </form>
      <vue-good-table
        :key="tableKey"
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :isLoading="tableData.isLoading"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdown: perPageDropdown,
          dropdownAllowAll: false,
          setCurrentPage: tableData.currentPage,
          infoFn: tablePageInfo,
        }"
        styleClass="vgt-table striped bordered"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'uuid'">
            <router-link
              v-if="userCan('update.bank')"
              :to="{ name: 'BankEdit', params: { id: props.row.uuid } }"
              v-tooltip="'Edit ' + props.row.name"
              class="table-action__link mx-2"
            >
              <font-awesome-icon :icon="['fas', 'edit']" />
            </router-link>
            <!-- <button
              v-if="userCan('export.crm')"
              class="table-action__link"
              v-tooltip="'Delete ' + props.row.name"
              @click="deleteItem(props.row.uuid, props.row.name)"
            >
              <font-awesome-icon :icon="['far', 'trash-alt']" />
            </button> -->
          </span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";
import { getListBankOptionsMixin } from "@/mixins/getListBankOptionsMixin";

export default {
  data: () => {
    return {
      formData: {
        search: "",
        group_id: ""
      },
      tableData: {
        columns: [
          {
            label: "Name",
            field: "name",
          },
          {
            label: "Bank Group",
            field: "group.name",
          },
          {
            label: "",
            field: "uuid",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
          },
        ],
        sort_by: "name",
        sort_dir: "asc",
      },
    };
  },
  created() {
    this.getListBankGroup()
  },
  mixins: [showListMixin,getListBankOptionsMixin],
  methods: {
    reset() {
      this.formData.search = "";
      this.tableData.limit = 10;
      this.formData.group_id = "";

      if (this.$route.query.search == undefined) {
        this.tableKey++;
      } else {
        this.tableData.currentPage = 1;
        this.$router.push({ name: "BankList" }).catch(() => {});
      }
    },
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.tableData.currentPage = 1;
        this.$router
          .replace({
            query: {
              search: this.formData.search,
              group_id: this.formData.group_id,
              tz: new Date().getTime()
            },
          })
          .catch(() => {});
      }
    },
  },
};
</script>